// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Currency from "../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Row$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CorePricingUtils from "../library/utils/CorePricingUtils.bs.js";
import * as CorePricingContext from "../library/core-pricing-context/CorePricingContext.bs.js";
import * as CorePricingTableVm from "../vm-mapper/CorePricingTableVm.bs.js";
import * as LabelUnit$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/label-unit/LabelUnit.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";
import * as CurrencyMajorMinorMapper from "../../../../../../library/data-source/country-currency/CurrencyMajorMinorMapper.bs.js";
import * as CorePricingTableTabHeader from "./CorePricingTableTabHeader.bs.js";
import * as LoadingViewComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/LoadingViewComponent.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

function CorePricingTable$CampaignsTable(Props) {
  var campaigns = Props.campaigns;
  var activeTabId = Props.activeTabId;
  var role = Props.role;
  var toggleSidebar = Props.toggleSidebar;
  var match = CountryContext.useContext(undefined);
  var currency = CountryConfig.getSymbol(match.country);
  var getScheduledAndActiveTableSchema = function (campaigns, toggleSidebar) {
    return {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "CAMPAIGN NAME"
              },
              accessor: (function (param) {
                  var cmp = param[0];
                  var campaign = List.find((function (c) {
                          switch (c.TAG | 0) {
                            case /* Pending */1 :
                            case /* Rejected */2 :
                                return cmp.campaign_id === c._0.campaign_id;
                            case /* Scheduled */0 :
                            case /* Deleted */3 :
                                return cmp.campaign_id === c.campaign.campaign_id;
                            
                          }
                        }), campaigns);
                  return {
                          TAG: /* ActionButton */3,
                          _0: cmp.campaign_name,
                          _1: (function (param) {
                              return Curry._1(toggleSidebar, {
                                          TAG: /* CampaignDetails */0,
                                          _0: campaign,
                                          _1: role
                                        });
                            })
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Custom */1,
                  _0: (function (param) {
                      return React.createElement(LabelUnit$Catalyst.make, {
                                  label: "BASE FARE",
                                  unit: currency
                                });
                    })
                },
                accessor: (function (param) {
                    return {
                            TAG: /* Text */0,
                            _0: Currency.toCurrencyString(CurrencyMajorMinorMapper.baseToCurrency(param[0].fare_details.base_fare), currency)
                          };
                  })
              },
              tl: {
                hd: {
                  column: {
                    TAG: /* Custom */1,
                    _0: (function (param) {
                        return React.createElement(LabelUnit$Catalyst.make, {
                                    label: "FREE DURATION",
                                    unit: "min"
                                  });
                      })
                  },
                  accessor: (function (param) {
                      return {
                              TAG: /* Text */0,
                              _0: String(CorePricingUtils.fromMilliSecToMins(param[0].fare_details.free_duration)) + " mins"
                            };
                    })
                },
                tl: {
                  hd: {
                    column: {
                      TAG: /* Custom */1,
                      _0: (function (param) {
                          return React.createElement(LabelUnit$Catalyst.make, {
                                      label: "FREE KMS",
                                      unit: "kms"
                                    });
                        })
                    },
                    accessor: (function (param) {
                        return {
                                TAG: /* Text */0,
                                _0: String(param[0].fare_details.free_slab.free_kms) + " kms"
                              };
                      })
                  },
                  tl: {
                    hd: {
                      column: {
                        TAG: /* Text */0,
                        _0: "START DATE"
                      },
                      accessor: (function (param) {
                          return {
                                  TAG: /* Text */0,
                                  _0: Timestamp$Catalyst.toString(param[0].start_date, "DD/MM/yyyy")
                                };
                        })
                    },
                    tl: {
                      hd: {
                        column: {
                          TAG: /* Text */0,
                          _0: "END DATE"
                        },
                        accessor: (function (param) {
                            var end_date = param[1];
                            if (end_date !== undefined) {
                              return {
                                      TAG: /* Text */0,
                                      _0: Timestamp$Catalyst.toString(Caml_option.valFromOption(end_date), "DD/MM/yyyy")
                                    };
                            } else {
                              return {
                                      TAG: /* Text */0,
                                      _0: "Infinite"
                                    };
                            }
                          })
                      },
                      tl: {
                        hd: {
                          column: {
                            TAG: /* Text */0,
                            _0: "CREATOR"
                          },
                          accessor: (function (param) {
                              return {
                                      TAG: /* Text */0,
                                      _0: param[0].created_by
                                    };
                            })
                        },
                        tl: {
                          hd: {
                            column: {
                              TAG: /* Text */0,
                              _0: "APPROVER"
                            },
                            accessor: (function (param) {
                                var approver = param[0].approved_by;
                                if (approver !== undefined) {
                                  return {
                                          TAG: /* Text */0,
                                          _0: approver
                                        };
                                } else {
                                  return {
                                          TAG: /* Text */0,
                                          _0: "N/A"
                                        };
                                }
                              })
                          },
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }
              }
            }
          };
  };
  var getPendingTableSchema = function (campaigns, toggleSidebar) {
    return {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "CAMPAIGN NAME"
              },
              accessor: (function (cmp) {
                  var campaign = List.find((function (c) {
                          switch (c.TAG | 0) {
                            case /* Pending */1 :
                            case /* Rejected */2 :
                                return cmp.campaign_id === c._0.campaign_id;
                            case /* Scheduled */0 :
                            case /* Deleted */3 :
                                return cmp.campaign_id === c.campaign.campaign_id;
                            
                          }
                        }), campaigns);
                  return {
                          TAG: /* ActionButton */3,
                          _0: cmp.campaign_name,
                          _1: (function (param) {
                              return Curry._1(toggleSidebar, {
                                          TAG: /* CampaignDetails */0,
                                          _0: campaign,
                                          _1: role
                                        });
                            })
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Custom */1,
                  _0: (function (param) {
                      return React.createElement(LabelUnit$Catalyst.make, {
                                  label: "BASE FARE",
                                  unit: currency
                                });
                    })
                },
                accessor: (function (cmp) {
                    return {
                            TAG: /* Text */0,
                            _0: Currency.toCurrencyString(CurrencyMajorMinorMapper.baseToCurrency(cmp.fare_details.base_fare), currency)
                          };
                  })
              },
              tl: {
                hd: {
                  column: {
                    TAG: /* Custom */1,
                    _0: (function (param) {
                        return React.createElement(LabelUnit$Catalyst.make, {
                                    label: "FREE DURATION",
                                    unit: "min"
                                  });
                      })
                  },
                  accessor: (function (cmp) {
                      return {
                              TAG: /* Text */0,
                              _0: String(CorePricingUtils.fromMilliSecToMins(cmp.fare_details.free_duration)) + " mins"
                            };
                    })
                },
                tl: {
                  hd: {
                    column: {
                      TAG: /* Custom */1,
                      _0: (function (param) {
                          return React.createElement(LabelUnit$Catalyst.make, {
                                      label: "FREE KMS",
                                      unit: "kms"
                                    });
                        })
                    },
                    accessor: (function (cmp) {
                        return {
                                TAG: /* Text */0,
                                _0: String(cmp.fare_details.free_slab.free_kms) + " kms"
                              };
                      })
                  },
                  tl: {
                    hd: {
                      column: {
                        TAG: /* Text */0,
                        _0: "START DATE"
                      },
                      accessor: (function (cmp) {
                          return {
                                  TAG: /* Text */0,
                                  _0: Timestamp$Catalyst.toString(cmp.start_date, "DD/MM/yyyy")
                                };
                        })
                    },
                    tl: {
                      hd: {
                        column: {
                          TAG: /* Text */0,
                          _0: "CREATOR"
                        },
                        accessor: (function (cmp) {
                            return {
                                    TAG: /* Text */0,
                                    _0: cmp.created_by
                                  };
                          })
                      },
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          };
  };
  var match$1 = CorePricingContext.useContext(undefined);
  switch (campaigns.TAG | 0) {
    case /* Loading */0 :
        return React.createElement(LoadingViewComponent$Catalyst.make, {});
    case /* Live */1 :
        var campaigns$1 = campaigns._0;
        var campaignsVm = CorePricingTableVm.getVM(campaigns$1);
        switch (activeTabId) {
          case /* Active */0 :
              if (List.length(campaignsVm.active) === 0) {
                return null;
              } else {
                return React.createElement(TableComponent$Catalyst.make, {
                            columns: getScheduledAndActiveTableSchema(campaigns$1, toggleSidebar),
                            rowData: campaignsVm.active,
                            className: "campaign-table"
                          });
              }
          case /* Scheduled */1 :
              if (List.length(campaignsVm.scheduled) === 0) {
                return null;
              } else {
                return React.createElement(TableComponent$Catalyst.make, {
                            columns: getScheduledAndActiveTableSchema(campaigns$1, toggleSidebar),
                            rowData: campaignsVm.scheduled,
                            className: "campaign-table"
                          });
              }
          case /* Pending */2 :
              if (List.length(campaignsVm.pending) === 0) {
                return null;
              } else {
                return React.createElement(TableComponent$Catalyst.make, {
                            columns: getPendingTableSchema(campaigns$1, toggleSidebar),
                            rowData: campaignsVm.pending,
                            className: "campaign-table"
                          });
              }
          
        }
    case /* Error */2 :
        return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                    error: campaigns._0,
                    refreshView: match$1.refetch_core_pricings,
                    refreshText: "Try Again"
                  });
    
  }
}

var CampaignsTable = {
  make: CorePricingTable$CampaignsTable
};

function CorePricingTable$CampaignTableSection(Props) {
  var campaigns = Props.campaigns;
  var role = Props.role;
  var activeTab = Props.activeTab;
  var toggleSidebar = Props.toggleSidebar;
  var match = CorePricingContext.useContext(undefined);
  return React.createElement("div", {
              className: "table-section"
            }, React.createElement("div", {
                  className: "tabs"
                }, React.createElement(CorePricingTableTabHeader.make, {
                      campaigns: campaigns,
                      activeTab: activeTab,
                      setActiveTab: match.setActiveTab
                    })), React.createElement("div", {
                  className: "tables"
                }, React.createElement(CorePricingTable$CampaignsTable, {
                      campaigns: campaigns,
                      activeTabId: activeTab,
                      role: role,
                      toggleSidebar: toggleSidebar
                    })));
}

var CampaignTableSection = {
  make: CorePricingTable$CampaignTableSection
};

function CorePricingTable(Props) {
  var role = Props.role;
  var campaigns = Props.campaigns;
  var activeTab = Props.activeTab;
  var toggleSidebar = Props.toggleSidebar;
  var match = CorePricingContext.useContext(undefined);
  return React.createElement("div", {
              className: "pricing-table-container"
            }, React.createElement(Row$Catalyst.make, {
                  children: null,
                  className: "result-description"
                }, React.createElement("div", undefined, "Showing results for"), React.createElement("b", {
                      className: "vehicle-name"
                    }, match.vehicle_type.vehicle_name), React.createElement("div", undefined, " in "), React.createElement("b", {
                      className: "georegion-name"
                    }, match.geo_region.geo_region_name)), React.createElement(CorePricingTable$CampaignTableSection, {
                  campaigns: campaigns,
                  role: role,
                  activeTab: activeTab,
                  toggleSidebar: toggleSidebar
                }));
}

var make = CorePricingTable;

export {
  CampaignsTable ,
  CampaignTableSection ,
  make ,
  
}
/* react Not a pure module */
